// Backend dates are "YYYY-MM-DD HH:mm:ss"; Safari can't parse the space
const parseDate = (value) => (value ? new Date(value.replace(' ', 'T')) : null);

// Returns the active promotion badge, or null. Dates are re-checked here
// because some products (e.g. recently viewed) come from stale local storage.
export const getPromo = (product) => {
  const event = product?.promotionEvent;
  if (!event?.seasonBadge || event.status !== 'live') return null;

  const now = Date.now();
  const start = parseDate(event.startDate);
  const end = parseDate(event.endDate);
  if (start && now < start.getTime()) return null;
  if (end && now > end.getTime()) return null;

  return { image: event.seasonBadge, label: event.label || 'On promo' };
};
